import React, { useState } from 'react';
import { Wine, Sparkles, Coffee, Beer, Flame, GlassWater, UtensilsCrossed } from 'lucide-react';
import MenuTabs from './menu/MenuTabs';
import CocktailsTab from './menu/CocktailsTab';
import WeineTab from './menu/WeineTab';
import { 
  cocktailsWithCream, 
  cocktailsWithoutCream, 
  mojitos,
  longdrinks,
  aperitif,
  cocktailsNonAlcoholic,
  wines025, 
  wines075,
  secco,
  shishaFlavors,
  shishaPrices,
  warmDrinks,
  softDrinks,
  beer,
  schnapps,
  foodMenu
} from '../data/mockData';

const MenuSection = () => {
  const [activeTab, setActiveTab] = useState('cocktails');

  const tabs = [
    { id: 'cocktails', label: 'Cocktails', icon: Sparkles },
    { id: 'weine', label: 'Weine', icon: Wine },
    { id: 'speisen', label: 'Speisen', icon: UtensilsCrossed },
    { id: 'shisha', label: 'Shisha', icon: Flame },
    { id: 'drinks', label: 'Drinks & Mehr', icon: GlassWater }
  ];

  return (
    <section id="menu" className="py-20 px-4" style={{ background: 'linear-gradient(to bottom, #1A0520, #0A0015)' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <Sparkles className="w-12 h-12 mx-auto mb-4 text-neon-pink" style={{ filter: 'drop-shadow(0 0 10px #FF00FF)' }} />
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{
            fontFamily: "'Playfair Display', serif",
            color: '#FF00FF',
            textShadow: '0 0 20px #FF00FF, 0 0 40px #FF00FF'
          }}>
            Unsere Karte Saale Lounge
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-neon-pink to-deep-violet mx-auto rounded-full" />
        </div>

        <MenuTabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === 'cocktails' && (
          <CocktailsTab 
            mojitos={mojitos}
            cocktailsWithCream={cocktailsWithCream}
            cocktailsWithoutCream={cocktailsWithoutCream}
            longdrinks={longdrinks}
            aperitif={aperitif}
            cocktailsNonAlcoholic={cocktailsNonAlcoholic}
          />
        )}

        {activeTab === 'weine' && (
          <WeineTab 
            wines025={wines025}
            wines075={wines075}
            secco={secco}
            schnapps={schnapps}
          />
        )}

        {activeTab === 'speisen' && (
          <div className="space-y-16">
            <div className="text-center mb-8">
              <h3 className="text-3xl font-bold text-neon-pink mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Für den kleinen Hunger
              </h3>
              <p className="text-white/60 text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Die Allergene hängen bei der Kasse aus
              </p>
            </div>

            {Object.entries(foodMenu).map(([category, items]) => (
              <div key={category}>
                <h3 className="text-2xl font-bold text-deep-violet mb-6 text-center capitalize" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {category === 'pinsa' ? 'Steinofenpinsa' : category}
                </h3>
                <div className={`grid grid-cols-1 ${category === 'flammkuchen' ? 'md:grid-cols-2' : 'md:grid-cols-2 lg:grid-cols-3'} gap-6`}>
                  {items.map((item) => (
                    <div key={item.id} className="glass-card p-6">
                      <h4 className="text-lg font-bold text-neon-pink mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                        {item.name}
                      </h4>
                      {item.description && (
                        <p className="text-white/70 text-sm mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                          {item.description}
                        </p>
                      )}
                      <p className="text-deep-violet text-lg font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                        {item.price}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        {activeTab === 'shisha' && (
          <div>
            <h3 className="text-3xl font-bold text-deep-violet mb-4 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
              Shisha Flavors
            </h3>
            <div className="text-center mb-8">
              <p className="text-white/70 text-lg" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Shisha: <span className="text-neon-pink font-bold">{shishaPrices.standard}</span> • Kopfwechsel: <span className="text-neon-pink font-bold">{shishaPrices.kopfwechsel}</span>
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {shishaFlavors.map((shisha) => (
                <div key={shisha.id} className="glass-card menu-card p-6">
                  <h4 className="text-xl font-bold text-deep-violet mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                    {shisha.name}
                  </h4>
                  <p className="text-white/70 text-sm mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                    {shisha.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'drinks' && (
          <div className="space-y-16">
            <div>
              <h3 className="text-3xl font-bold text-neon-pink mb-8 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
                <Coffee className="w-8 h-8 inline-block mr-2" />
                Warme Getränke
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {['coffee', 'tea', 'coffeeSpecials'].map((category) => (
                  <div key={category}>
                    <h4 className="text-xl font-bold text-deep-violet mb-4 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {category === 'coffee' ? 'Kaffee' : category === 'tea' ? 'Tee' : 'Kaffee Specials'}
                    </h4>
                    <div className="space-y-2">
                      {warmDrinks[category].slice(0, category === 'coffeeSpecials' ? 4 : undefined).map((item) => (
                        <div key={item.id} className="glass-card p-3 flex justify-between items-center">
                          <span className="text-white text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                            {item.name}
                          </span>
                          <span className="text-neon-pink font-bold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                            {item.price}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-neon-pink mb-8 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
                <Beer className="w-8 h-8 inline-block mr-2" />
                Bier
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {Object.entries(beer).map(([type, items]) => (
                  <div key={type}>
                    <h4 className="text-xl font-bold text-deep-violet mb-4 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {type === 'draft' ? 'Vom Fass' : 'Aus der Flasche'}
                    </h4>
                    <div className="space-y-2">
                      {items.map((item) => (
                        <div key={item.id} className="glass-card p-3 flex justify-between items-center">
                          <span className="text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                            {item.name}
                          </span>
                          <span className="text-neon-pink font-bold" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                            {item.price}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-3xl font-bold text-neon-pink mb-8 text-center" style={{ fontFamily: "'Playfair Display', serif" }}>
                <GlassWater className="w-8 h-8 inline-block mr-2" />
                Soft Drinks
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {Object.entries(softDrinks).map(([category, items]) => (
                  <div key={category}>
                    <h4 className="text-lg font-bold text-deep-violet mb-4 text-center capitalize" style={{ fontFamily: "'Playfair Display', serif" }}>
                      {category === 'tradeIsland' ? 'Trade Island' : 
                       category === 'redBull' ? 'Red Bull' : 
                       category === 'juices' ? 'Säfte & Schorlen' :
                       category}
                    </h4>
                    <div className="space-y-2">
                      {items.map((item) => (
                        <div key={item.id} className="glass-card p-2 flex justify-between items-center">
                          <span className="text-white text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                            {item.name}
                          </span>
                          <span className="text-neon-pink font-bold text-sm" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                            {item.price}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default MenuSection;
